export {}

const iframeWrapper = document.querySelector<HTMLElement>(".s-tickets__goout")
const gooutUrl = iframeWrapper?.dataset.gooutUrl
const tickets = document.querySelectorAll<HTMLElement>(".i-ticket[data-goout-id]")
const gooutBlock = document.querySelector<HTMLElement>(".--js-goout-block")
const GOUT_READY_EVENT_KEY = "gooutReady"

type Message = {
  tickets: {
    [ticketId: number]: number
  }
}

const GOOUT = {
  init: function (callback: () => void) {
    const script = document.createElement("script")
    script.src = "https://partners.goout.net/framework/widgets-api.js"
    document.body.appendChild(script)
    window.addEventListener("goApiReady", callback)
  },
}

GOOUT.init(function () {
  goOut.frame(iframeWrapper, gooutUrl)
  document.dispatchEvent(new Event(GOUT_READY_EVENT_KEY))
})

const handleGooutScroll = () => {
  if (!gooutBlock) return

  if (!gooutBlock.classList.contains("--toggled")) gooutBlock.classList.add("--toggled")
  gooutBlock.scrollIntoView({
    behavior: "smooth",
    block: "start",
    inline: "nearest",
  })
}

const handleGooutMessage = (ticketId: number, ticketsCount: number) => {
  const iframe = iframeWrapper?.querySelector("iframe")

  if (!iframe || !iframe.contentWindow || !ticketsCount || !gooutUrl) return

  const message: Message = {
    tickets: {
      [ticketId]: ticketsCount,
    },
  }
  console.log(message)
  iframe.contentWindow.postMessage(message, gooutUrl)
}

document.addEventListener(GOUT_READY_EVENT_KEY, () => {
  const currentUrl = new URL(window.location.href)
  const ticketId = Number(currentUrl.searchParams.get("ticketId"))
  const ticketCount = Number(currentUrl.searchParams.get("count") ?? 1)

  const iframe = document.querySelector<HTMLIFrameElement>(".goOutFrame")

  if (!ticketId || !iframe) return

  iframe.onload = () => {
    function checkIfLoaded() {
      if (document.readyState === "complete") {
        handleGooutScroll()
        handleGooutMessage(ticketId, Number(ticketCount))
      } else {
        setTimeout(checkIfLoaded, 500)
      }
    }
    checkIfLoaded()
  }
})

if (iframeWrapper) {
  tickets.forEach((ticket) => {
    const buyButton = ticket.querySelector<HTMLElement>(".i-ticket__cta")
    const gooutTicketId = Number(ticket.dataset.gooutId)

    if (!buyButton || !gooutTicketId) return

    buyButton.addEventListener("click", (e) => {
      e.preventDefault()

      const counterInput = ticket.querySelector<HTMLInputElement>(".c-counter input")

      if (counterInput) {
        handleGooutMessage(gooutTicketId, Number(counterInput.value))
        handleGooutScroll()
      }
    })
  })
}
